import { render, staticRenderFns } from "./fanzhuan.vue?vue&type=template&id=31f90b16&scoped=true&"
import script from "./fanzhuan.vue?vue&type=script&lang=js&"
export * from "./fanzhuan.vue?vue&type=script&lang=js&"
import style0 from "./fanzhuan.vue?vue&type=style&index=0&id=31f90b16&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f90b16",
  null
  
)

export default component.exports